import React from "react";

import { SpinnerContainer } from "./style";

export const Spinner = () => {
  return <SpinnerContainer />;
};

export default Spinner;
